import React from "react";
import {
  NotFound,
  WarehousesList,
  WarehouseEdit,
  WarehouseEmptyPositions,
  WarehouseDoublePositions,
  WarehouseClosePositions,
  WarehouseEmptyStockPositions,
  //
  ProductsList,
  ProductsEdit,
  //
  GrnsList,
  GrnEdit,
  //
  GdnsList,
  GdnPreview,
  GdnsFastShipment,
  //
  PacksList,
  //
  MissingsList,
  ProductsFindByExpanoPimId,
  //
  CompletingPacks,
  CompletingGdns,
  CompletingPackGdn,
  //
  SortingList,
  //
  SuppliersList,
  SupplierNew,
  SupplierEdit,
  //
  CartsList,
  PackerDashboard,
} from "../../pages";

import { Switch, Route } from "react-router-dom";

const WarehousemanRoutes = () => {
  return (
    <Switch>
      <Route exact={true} path="/" component={PackerDashboard} />
      <Route exact={true} path="/products" component={ProductsList} />
      <Route
        exact={true}
        path="/products/find_by_expano_pim_id"
        component={ProductsFindByExpanoPimId}
      />
      <Route
        exact={true}
        path="/products/:id/:type*"
        component={ProductsEdit}
      />
      <Route exact={true} path="/products" component={ProductsList} />
      <Route exact={true} path="/missings" component={MissingsList} />
      <Route exact={true} path="/grns" component={GrnsList} />
      <Route exact={true} path="/grns/:id" component={GrnEdit} />
      <Route exact={true} path="/gdns" component={GdnsList} />
      <Route
        exact={true}
        path="/gdns/fast_shipments"
        component={GdnsFastShipment}
      />

      <Route exact={true} path="/gdns/:id" component={GdnPreview} />
      <Route exact={true} path="/packs" component={PacksList} />
      <Route exact={true} path="/packing" component={CompletingPacks} />
      <Route
        exact={true}
        path="/packing/gdn_pack/:pack_id"
        component={CompletingGdns}
      />
      <Route
        exact={true}
        path="/packing/gdn/:id"
        component={CompletingPackGdn}
      />
      <Route exact={true} path="/sorting" component={SortingList} />
      <Route exact={true} path="/suppliers" component={SuppliersList} />
      <Route exact={true} path="/suppliers/new" component={SupplierNew} />
      <Route exact={true} path="/suppliers/:id" component={SupplierEdit} />
      <Route exact={true} path="/warehouses" component={WarehousesList} />
      <Route
        exact={true}
        path="/warehouses/:id/empty_positions"
        component={WarehouseEmptyPositions}
      />
      <Route
        exact={true}
        path="/warehouses/:id/double_positions"
        component={WarehouseDoublePositions}
      />
      <Route
        exact={true}
        path="/warehouses/:id/close_positions"
        component={WarehouseClosePositions}
      />
      <Route
        exact={true}
        path="/warehouses/:id/empty_stock_positions"
        component={WarehouseEmptyStockPositions}
      />
      <Route
        exact={true}
        path={[
          "/warehouses/:warehouse_id",
          "/warehouses/:warehouse_id/rooms/:warehouse_room_id",
          "/warehouses/:warehouse_id/rooms/:warehouse_room_id/aisles/:warehouse_aisle_id",
          "/warehouses/:warehouse_id/rooms/:warehouse_room_id/aisles/:warehouse_aisle_id/racks/:warehouse_rack_id",
        ]}
        component={WarehouseEdit}
      />
      <Route exact={true} path="/carts" component={CartsList} />
      <Route component={NotFound} />
    </Switch>
  );
};

export default WarehousemanRoutes;
